import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ExpandableCard from './components/ExpandableCard';
import styles from './Information.module.scss';

const Information = ({ componentRef }) => {
  // Get the number of tuition sessions, fallback to 2 if not available
  // const sessionsPerMonth = invitationDetails?.tuition_sessions_per_month || 2;

  return (
    <div className={styles['information-wrapper']} ref={componentRef}>
      <h2>Information</h2>
      <ExpandableCard
        title="What is the Meet Your Coach Session?"
        response={
          <div className={styles['response']}>
            It&apos;s a 15-minute video call that introduces you to your coach. You will talk about yourselves, your careers, and review your learning
            goals. You&apos;ll also go over the course structure and discuss what to do next.
          </div>
        }
      />
      <ExpandableCard
        title="What do I need to do to prepare for my Meet Your Coach session?"
        response={
          <div className={styles['response']}>
            <p>There&apos;s nothing you need to prepare, so we recommend booking it as soon as possible.</p>
          </div>
        }
      />
      <ExpandableCard
        title="Can I change my coach in the future?"
        response={
          <p>
            Yes. While we recommend staying with the same coach once you&apos;ve found one that suits you, you do have the option to switch at any
            time.
          </p>
        }
      />
      <ExpandableCard
        title="What happens after the Meet Your Coach session?"
        response={
          <p>
            The course officially begins. You will study grammar and vocabulary independently using our AI-powered memorisation platform, then
            practice your new language skills in a Live Practice class with your coach. This is called the “flipped classroom” approach, and it&apos;s
            one of the most efficient and engaging ways to learn.
          </p>
        }
      />
      <ExpandableCard
        title="What is independent learning like?"
        response={
          <p>
            You&apos;ll use Cerego™-powered AI technology to quickly and effectively build your knowledge of grammar and vocabulary. Each class
            requires about 2 hours of self-study, which you can work through little by little, whenever it suits you. Be sure to complete 100% of each
            self-study lesson to get the most out of your sessions with your coach.
          </p>
        }
      />
      <ExpandableCard
        title="What are Live Practices?"
        response={
          <div className={styles['response']}>
            <p>
              Live Practices are one-on-one video call sessions with your coach, who is a native speaker. These sessions help you apply your language
              skills through real-life activities. Based on your plan, you will have 2 or 4 Live Practice sessions per month. Any unused sessions will
              automatically carry over to the next month, but only once. If you don&apos;t use them by the end of that second month, they will expire.
            </p>
          </div>
        }
      />
    </div>
  );
};

Information.propTypes = {
  componentRef: PropTypes.object,
  invitationDetails: PropTypes.object
};

// Map Redux state to component props
const mapStateToProps = (state) => ({
  invitationDetails: state.invitation.details
});

// Connect the component to Redux
export default connect(mapStateToProps)(Information);
